module.exports = __webpack_public_path__ + "img/5423f07.svg";